import { render, staticRenderFns } from "./ToggleMenu.vue?vue&type=template&id=4bf94989&scoped=true&"
var script = {}
import style0 from "./ToggleMenu.vue?vue&type=style&index=0&id=4bf94989&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf94989",
  null
  
)

export default component.exports